export enum LiwGamesOddsType {
  DECIMAL = 0,
  AMERICAN = 1,
  FRACTIONAL = 5
}

export enum SevenOddsType {
  DECIMAL = 1,
  FRACTIONAL = 2,
  AMERICAN = 3
}

export interface ApiConfiguration {
  partnerName: string;
  gameId: string;
  skin: number;
}

export type Token = string | undefined | null;

export interface IntegratorInstance {
  sendMessage: {
    (message: string): void;
  };
}
export interface IntegratorInitialResolve {
  (payload: IntegratorResponseData): void;
}

export interface IntegratorResponseData {
  auth: { token: Token; user: { id: string }; id: string };
  tenant: { uuid: string };
  currency: { symbol: string };
  locale: { iso1: string };
  settings: { oddType: SevenOddsType };
}
